import { GetterTree } from 'vuex'

import { ArchivesState } from './state'

export const getters: GetterTree<ArchivesState, ArchivesState> = {
  metadata: state => state.config?.metadata,
  sections: state => state.config?.sections,
  selectedDocumentsSize: state => state.selectedDocuments.reduce((accSum, item) => accSum + item.docSize, 0),
}
